import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EndDeviceAssignment, EndDeviceAssignmentModel } from 'src/app/models/deviceAssignment.model';
import { SensorAssignmentService } from 'src/app/services/sensorAssignment.service';
import { FormComponent, IFormDialogData } from 'src/app/shared/form/form.component';
import { DateFormField, MultiSelectionFormField } from 'src/app/shared/form/formField.model';
import { ILookup } from 'src/app/shared/form/lookup.model';
import nameOf from 'src/app/shared/form/nameOf.helper';

export interface IEndDeviceAssignmentDialogData extends IFormDialogData {
    assignments: EndDeviceAssignmentModel[];
}

@Component({
  standalone: false,
    selector: 'app-end-device-assignment-dialog',
    templateUrl: './../../shared/form/form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./../../shared/form/form.component.scss'],
})
export class EndDeviceAssignmentDialogComponent extends FormComponent<EndDeviceAssignment> implements OnInit {
    devices: ILookup[] = [];

    constructor(
        dialogRef: MatDialogRef<EndDeviceAssignmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IEndDeviceAssignmentDialogData,
        protected injector: Injector,
        private sensorAssignmentService: SensorAssignmentService
    ) {
        super(dialogRef, null, data, 'End Device Assignment', injector);
        this.setMainButtonText('Save');
        this.setMainButtonClick(() => {
            this.saveDeviceAssignments();
        });
        const title = `End Device ${this.data.assignments.length > 1 ? 'Assignments' : 'Assignment'}`;
        this.setTitle(title, false);
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        this.initModel();
        this.initFields();
        this.isFormLoading = false;
    }

    initModel(): void {
        this.entity = this.getNewObject();
        this.devices = this.data.assignments.map(a => ({ id: a.deviceId, name: a.deviceName }));
        this.entity.endDateTime = this.dateFormatService.formatDateTimeToString(new Date(), this.dateFormatService.dateToStringFormat);
        this.entity.selection = this.data.assignments.length === 1
            ? [this.data.assignments[0].deviceId]
            : [];
    }

    getNewObject(): EndDeviceAssignment {
        return new EndDeviceAssignment();
    }

    validate(): boolean {
        return true;
    }

    initFields(): void {
        this.fields = [
            new MultiSelectionFormField({
                property: nameOf<EndDeviceAssignment>(x => x.selection),
                name: this.data.assignments.length > 1 ? 'Devices' : 'Device',
                options: this.devices
            }),
            new DateFormField({
                property: nameOf<EndDeviceAssignment>(x => x.endDateTime),
                name: 'End Date',
            }),
        ];
    }

    saveDeviceAssignments(): void {
        const endDate = this.dateFormatService.convertStringToTimestamp(this.entity.endDateTime);
        const selectedAssignments = this.data.assignments.filter(a =>
            this.entity.selection?.includes(a.deviceId)
        );

        let completed = 0;
        for (const assignment of selectedAssignments) {
            this.sensorAssignmentService.patchEndDate(assignment.sensorAssignmentId, { endDate }).subscribe({
                next: () => {
                    this.toastService.showSuccess('End date saved for device {{deviceName}}', true, { deviceName: assignment.deviceName });
                },
                error: () => {
                    this.toastService.displayErrorMessage('Failed to save end date for device {{deviceName}}', true, { deviceName: assignment.deviceName });
                },
                complete: () => {
                    completed++;
                    if (completed === selectedAssignments.length) {
                        this.dialogRef.close(true);
                    }
                }
            });
        }
    }
}